import { render, staticRenderFns } from "./fifteen.vue?vue&type=template&id=08ce4ad2&scoped=true&"
import script from "./fifteen.vue?vue&type=script&lang=js&"
export * from "./fifteen.vue?vue&type=script&lang=js&"
import style0 from "./fifteen.vue?vue&type=style&index=0&id=08ce4ad2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ce4ad2",
  null
  
)

component.options.__file = "fifteen.vue"
export default component.exports